import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import { Suspense } from "react";
import { useIsHdcMember } from "../../app/Providers/DriversClubContext";
import { useIsPolicyHolder } from "../../app/Providers/PolicyContext";
import { LoadingRow } from "../LoadingRow";
import {
  BillingAlerts as BillingAlertsUnwrapped,
  BillingRegion,
} from "./BillingAlerts";
import { ErrorRow } from "../ErrorRow";
import { useIsStateFarmSsoLogin } from "../../hooks/useIsStateFarmSsoLogin";

const BillingAlertsFallback = ({ resetErrorBoundary }: FallbackProps) => {
  return (
    <BillingRegion>
      <ErrorRow resetErrorBoundary={resetErrorBoundary} />
    </BillingRegion>
  );
};

const BillingAlertsLoading = () => {
  return (
    <BillingRegion>
      <LoadingRow />
    </BillingRegion>
  );
};

export const BillingAlerts = () => {
  const isStateFarmSsoLogin = useIsStateFarmSsoLogin();
  const { isHdcMember } = useIsHdcMember();
  const { isPolicyHolder } = useIsPolicyHolder();

  // Always show billing if user has HDC
  // Only show billing for policy holders if not StateFarm SSO
  const showBilling = isHdcMember || (isPolicyHolder && !isStateFarmSsoLogin);

  // Until we know whether to render billing, hide upcoming bills region loading/error components
  const errorComponent = showBilling ? BillingAlertsFallback : () => null;
  const loadingComponent = showBilling ? <BillingAlertsLoading /> : null;

  return (
    <ErrorBoundary FallbackComponent={errorComponent}>
      <Suspense fallback={loadingComponent}>
        <BillingAlertsUnwrapped showBilling={!!showBilling} />
      </Suspense>
    </ErrorBoundary>
  );
};
